import { selectedSpaceAtom } from "@/atoms/spaces"
import { useRecoilValue } from "recoil"
import { useRouter } from "next/router"
import { CustomerType } from "@/modules/space/constants/customerType"

function DashboardPage() {
  const selectedSpace = useRecoilValue(selectedSpaceAtom)
  const router = useRouter()

  if (selectedSpace.settings.enable_approval_dashboard) {
    router.push("/home")
  }

  if (
    selectedSpace?.isOrganization &&
    !selectedSpace.settings?.disabled_internal_proposals &&
    selectedSpace?.customerType !== CustomerType.RFQReceiver
  ) {
    router.push("/shared")
  } else {
    router.push("/supplier/opportunities")
  }
}

export default DashboardPage
